import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  logo = false;

  position = new BehaviorSubject<string>('');
  currentPos = this.position.asObservable();

  constructor() { }

  showLogo(){
    this.logo = true;
  }

  updateLocation(location){
    this.position.next(location);
  }

}
